import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import { Hero } from "@gorilla-technologies/customer-ui"

export type HeroBlockProps = {
  backgroundImage: {
    asset: {
      gatsbyImageData: IGatsbyImageData
    }
  }
}

export const HeroBlock = ({ backgroundImage }: HeroBlockProps) => {
  return (
    <Hero
      image={
        <GatsbyImage
          image={backgroundImage.asset.gatsbyImageData}
          alt="hero"
          className="h-52 w-full object-cover lg:h-96"
        />
      }
    />
  )
}

export const HeroBlockFragment = graphql`
  fragment HeroFields on SanityHero {
    backgroundImage {
      asset {
        gatsbyImageData
      }
    }
  }
`
